import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Callout, Column, TextButton } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useGetInfo } from '~/hooks/useGetInfo';
import { useUpdateVendorUiPreference } from '~/hooks/useUpdateUiPreference';
import { useLocaleKeys } from '~/i18n';
export const GetSalesTaxDashboardCalloutTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const SalesTaxDashboardCallout = ()=>{
    var _businessInfo_uiPreferences;
    const { SALES_TAX } = useFeatureFlags();
    const { t } = useLocaleKeys('billing.salesTaxDashboardCallout');
    const navigate = useNavigate();
    const { businessInfo } = useGetInfo();
    const { updateUiPreference } = useUpdateVendorUiPreference();
    const { SalesTaxDashboardCalloutTID } = useMemo(()=>GetSalesTaxDashboardCalloutTID(), []);
    if (!SALES_TAX) return null;
    if (businessInfo == null) return null;
    if (((_businessInfo_uiPreferences = businessInfo.uiPreferences) === null || _businessInfo_uiPreferences === void 0 ? void 0 : _businessInfo_uiPreferences.hideSetUpSalesTaxCallout) === true) return null;
    return /*#__PURE__*/ _jsx(Column, {
        width: "100%",
        style: {
            paddingBlock: 8
        },
        children: /*#__PURE__*/ _jsx(Callout, {
            testId: SalesTaxDashboardCalloutTID.Root(),
            intent: "info",
            onDismiss: ()=>updateUiPreference({
                    key: 'hideSetUpSalesTaxCallout',
                    value: true
                }),
            withAction: /*#__PURE__*/ _jsx(TextButton, {
                bi: {
                    name: 'sales_tax_dashboard_callout_cta'
                },
                underline: "none",
                onClick: ()=>navigate(routes.salesTax),
                children: t.cta()
            }),
            children: t.message()
        })
    });
};
